import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import labelState from './modules/label'
import alterState from './modules/alter'
import verifyState from './modules/verify'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        login,
        labelState,
        alterState,
		verifyState
    }
})